/* Daily Dons — email-popup.js
   The two-step discount popup, ported from EmailPopup.tsx.
   Triggers: exit-intent (mouse leaves through viewport top) OR 50% scroll
   depth. Dismissal snoozes it for 14 days (localStorage); subscribing hides
   it forever. Subscribe posts the native Shopify customer form via fetch so
   the success step (discount code) shows without a page reload, and degrades
   to a normal form POST without JS. */
(function () {
  'use strict';

  var DISMISS_KEY = 'dd-popup-dismissed';
  var SUBSCRIBED_KEY = 'dd-popup-subscribed';
  var DISMISS_DAYS = 14;

  function shouldShow() {
    try {
      if (localStorage.getItem(SUBSCRIBED_KEY)) return false;
      var dismissed = localStorage.getItem(DISMISS_KEY);
      if (dismissed && Date.now() - Number(dismissed) < DISMISS_DAYS * 864e5) return false;
      return true;
    } catch (e) { return false; }
  }

  function init(popup) {
    var fired = false;

    function fire() {
      if (fired) return;
      fired = true;
      if (shouldShow() && window.DDOverlays) window.DDOverlays.show(popup);
    }

    function onMouseOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) fire();
    }
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.5) fire();
    }

    if (!shouldShow()) return;
    document.addEventListener('mouseout', onMouseOut);
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Step navigation */
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-yes]')) {
        popup.querySelector('[data-popup-step="ask"]').hidden = true;
        popup.querySelector('[data-popup-step="email"]').hidden = false;
        var input = popup.querySelector('input[type="email"]');
        if (input) input.focus();
      }
    });

    /* Dismiss = snooze */
    popup.addEventListener('dd:modal:close', function () {
      try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
    });

    /* Native customer form via fetch → success step */
    var form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var errEl = popup.querySelector('[data-popup-error]');
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-busy-label') || btn.textContent; }
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html' }
        }).then(function (res) {
          if (!res.ok) throw new Error('bad status');
          popup.querySelector('[data-popup-step="email"]').hidden = true;
          popup.querySelector('[data-popup-step="done"]').hidden = false;
          try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (err) {}
        }).catch(function () {
          if (errEl) errEl.hidden = false;
        }).finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || btn.textContent; }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('[data-email-popup]');
    if (popup) init(popup);
  });
})();
